module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    attrs: {
      "id": "season"
    }
  }, [_c('ol', {
    staticClass: "breadcrumb pull-right"
  }, [_c('li', [_c('router-link', {
    attrs: {
      "to": {
        path: '/'
      }
    }
  }, [_vm._v("Home")])], 1), _vm._v(" "), _c('li', [_vm._v("Duel")]), _vm._v(" "), _c('li', {
    staticClass: "active"
  }, [_vm._v("List Season")])]), _vm._v(" "), _c('h1', {
    staticClass: "page-header"
  }, [_vm._v("List Season")]), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-12"
  }, [_c('div', {
    staticClass: "panel panel-inverse"
  }, [_c('div', {
    staticClass: "panel-heading"
  }, [_c('div', {
    staticClass: "pull-right"
  }, [_c('button', {
    staticClass: "btn btn-success btn-xs m-r-5",
    attrs: {
      "type": "button"
    },
    on: {
      "click": function($event) {
        return _vm.createSeason()
      }
    }
  }, [_c('span', {
    staticClass: "fa fa-plus"
  }), _vm._v(" Tambah Season")])]), _vm._v(" "), _c('h4', {
    staticClass: "panel-title"
  }, [_vm._v("List Season")])]), _vm._v(" "), _c('div', {
    staticClass: "panel-body"
  }, [_c('app-datatable', {
    attrs: {
      "items": _vm.seasonList,
      "headers": _vm.headers
    },
    on: {
      "dblClicked": function($event) {
        return _vm.updateSeason()
      },
      "deleted": function($event) {
        return _vm.deleteSeason($event)
      },
      "selected": function($event) {
        _vm.selectedRow = $event
      }
    }
  })], 1)])])]), _vm._v(" "), (_vm.isLoading) ? _c('app-spinner') : _vm._e()], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-35e2ecaf","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/duel/season/Season.vue
// module id = 1321
// module chunks = 0